module.exports = __webpack_public_path__ + "static/media/install_android.1e54fe60.png";